import {Box, Container, Link, Typography} from "@mui/material";

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={(theme) => ({
                borderTop: `1px solid ${theme.palette.divider}`,
                py: 2,
            })}
        >
            <Container maxWidth="xl">
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                    }}
                >
                    <Typography variant="caption" color="text.secondary">
                        © {year} BITLAB ACADEMY · Developed by{" "}
                        <Link
                            href="https://www.linkedin.com/in/ilyas-zhuanyshev/"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                            sx={{
                                fontWeight: 700,
                                color: "inherit",
                            }}
                        >
                            Ilyas Zhuanyshev
                        </Link>
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
